import { useEffect, useState } from "react";

import ConsultationList from "./ConsultationList/ConsultationList";
import ServiceDetail from "../../../dev/Services/ServiceDetail";

import { fetchAllSelfPublishingsPersonal, fetchSelfPublishingDetailedPersonal } from "../../../Api/Backend/SelfPublishing";
import { useAuth } from "../../../Context/AuthContext";


function ConsultationHistory({ }) {
    const auth = useAuth();
    const [selfPublishings, setSelfPublishings] = useState([]);
    const [detailedData, setDetailedData] = useState(null);

    const [isDetailViewActive, setIsDetailViewActive] = useState(false);

    const handleDetailViewBackClick = () => {
        setIsDetailViewActive(false);
        setDetailedData(null);
    }

    const handleFetchSelfPublishings = async () => {
        await fetchAllSelfPublishingsPersonal({
            auth: auth,
            onSuccess: (data) => {
                // console.log("Personal Self Publishings: ", data);
                setSelfPublishings(data);
            },
            onError: (error) => {
                console.error("Error encountered during Self Publishings fetch: ", error?.message || error);
            }
        })
    };

    const handleFetchSelfPublishingsDetailed = async (selfPublishingId) => {
        await fetchSelfPublishingDetailedPersonal({
            auth: auth,
            selfPublishingId: selfPublishingId,
            onSuccess: (data) => {
                // console.log("Detailed personal Self Publishing: ", data);
                setDetailedData(data);
                setIsDetailViewActive(true);
            },
            onError: (error) => {
                console.error("Error encountered during detailed Self Publishing fetch: ", error?.message || error);
            }
        })
    }

    useEffect(() => {
        handleFetchSelfPublishings();
    }, []);

    return (
        <>
            {isDetailViewActive && detailedData ? (
                <ServiceDetail detailedData={detailedData} onBackClick={handleDetailViewBackClick} />
            ) : (
                <ConsultationList consultationData={selfPublishings} onEntryClick={handleFetchSelfPublishingsDetailed} />
            )}
        </>
    );
}

export default ConsultationHistory;